import React, { Component } from 'react'
import { noMoreLonelyWords } from './utilities/utilities.js';


class Biography extends Component {
  constructor(props) {
    super(props)    
    this.state = {    
      loading: false
    }
  }

  componentDidUpdate() {
    noMoreLonelyWords("p", 2)
  }


  render() {
    const style = this.state.loading ? {} : { display: 'none' }
    const { loading } = this.state;
    return (
      <div className="nota-biografica">

        {this.props.data.text && this.props.data.text.map((bio) => {
          return (
            <p key={bio} className="texto-intro">
              {bio}
            </p>
          )
        })
        }
        <div className="image-container">
          {!loading && <i className="fa fa-spinner animated"></i>}
          <img src={this.props.data.photo && `/images/${this.props.data.photo}`} alt=""
            onLoad={() => this.setState({ loading: true })}
            style={style}
          />
        </div>
      </div>
    )
  }
}


export default Biography


// WEBPACK FOOTER //
// ./src/Biography.js